import { i18n } from "./init-i18next";

/**
 * Maps an API error code to a translated user-facing message.
 * Falls back to "errors.somethingWentWrong" (common namespace) if the code is unknown.
 *
 * Uses the i18n instance directly to support dynamic key lookup without
 * conflicting with i18next's strict typed key constraints. The common namespace
 * is the default, so "errors.somethingWentWrong" resolves to common.errors.somethingWentWrong.
 */
export function mapApiError(code: string | undefined): string {
  if (!code) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return i18n.t("errors.somethingWentWrong" as any);
  }

  const key = `errors.api.${code}`;
  const exists = i18n.exists(key);

  if (!exists) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return i18n.t("errors.somethingWentWrong" as any);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return i18n.t(key as any);
}
